import { combineReducers } from "redux";
import userReducer from "./userReducer";
import authReducer from "./authReducer";
import schedulersReducer from "./schedulersReducer";
import categoriesReducer from "./categoriesReducer";
import fleetsReducer from "./fleetsReducer";
import otaUpdatesReducer from "./otaUpdatesReducer";
import commonReducer from "./commonReducer";
import dashboardReducer from "./dashboardReducer";
import alertRulesReducer from "./alertRulesReducer";

const appReducer = combineReducers({
  users: userReducer,
  auth: authReducer,
  schedulers: schedulersReducer,
  categories: categoriesReducer,
  otaUpdates: otaUpdatesReducer,
  fleets: fleetsReducer,
  common: commonReducer,
  dashboard: dashboardReducer,
  alertRules: alertRulesReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    const { isDarkMode } = state.common;
    state = {
      common: {
        ...state.common,
        isDarkMode,
      },
    };
  }
  return appReducer(state, action);
};

export default rootReducer;
